import HeaderWidgetCaseTime from './HeaderWidgetCaseTime.vue';
import { Service } from './Service.ts';

export { CaseTime, createContext, CASE_TIME_CONTEXT } from './CaseTime/index';

HeaderWidgetCaseTime.Service = Service;

export default HeaderWidgetCaseTime;
